import createComponent from '@carvana/merch-components/createComponent';

export const ContactContainer = createComponent('div', {
  className: 'flex flex-row gap-md'
});

export const IconWrapper = createComponent('div', {
  className: 'flex h-2xl w-xl items-center text-text-strong'
});

export const Line = createComponent('hr', {
  className: 'sm:h-xl sm:self-center sm:border-r sm:border-border-weak'
});

export const MapWrapper = createComponent('div', {
  className:
    'relative h-[120px] overflow-hidden rounded-lg bg-cover bg-center bg-no-repeat sm:h-[240px]'
});

export const Heading = createComponent('h2', {
  className: 't-heading-lg sm:t-heading-xl'
});

export const Label = createComponent('span', {
  className: 't-label-sm'
});

export const Row = createComponent('div', {
  className: 'flex flex-row justify-between text-text-default t-body-sm'
});

export const HoursWrapper = createComponent('div', {
  className: 'flex w-full flex-col gap-md'
});

export const RowWrapper = createComponent('div', {
  className: 'flex flex-col gap-sm'
});
